import { render } from "./PrintLegBlock.vue?vue&type=template&id=6404b9ac&scoped=true"
import script from "./PrintLegBlock.vue?vue&type=script&lang=js"
export * from "./PrintLegBlock.vue?vue&type=script&lang=js"

import "./PrintLegBlock.vue?vue&type=style&index=0&id=6404b9ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6404b9ac"]])

export default __exports__